import React from 'react';

import { CardCvcElement } from '@stripe/react-stripe-js';
import type { StripeCardCvcElementChangeEvent } from '@stripe/stripe-js';

import { stripeElementDomId } from '#src/app/shared/utils/payments';

type Props = {
	onChange?: (event: StripeCardCvcElementChangeEvent) => unknown;
	onFocus?: () => void;
	onBlur?: () => void;
};

export const CardCvcElementWrapper: React.FC<Props> = ({ onChange, onFocus, onBlur }) => {
	return (
		<CardCvcElement
			id={stripeElementDomId('cardCvc')}
			options={{ style: { base: { fontSize: '16px' } } }}
			onChange={onChange}
			onFocus={onFocus}
			onBlur={onBlur}
		/>
	);
};
